import { Autocomplete, TextField } from '@mui/material';
import { useState } from 'react';

export const ExerciseSynonymInput = (props: { synonyms: Array<string>; setExerciseSynonyms: (synonyms: Array<string>) => void }) => {
  const { synonyms, setExerciseSynonyms } = props;

  return (
    <Autocomplete
      multiple
      freeSolo
      options={[]}
      value={synonyms}
      onChange={(_, newValue) => setExerciseSynonyms(newValue)}
      renderInput={(params) => <TextField {...params} label="Exercise Synonyms" placeholder="Enter synonym and press enter." />}
    />
  );
};
